// Sdílení do Wac Buddy z jiných aplikací (Android share intent, plugin send-intent).
// Sdílený text se otevře v chatu s Buddym jako rozepsaná zpráva, nic se neodesílá samo.
import { AI_NOTE_MAX_LENGTH } from '@wac-buddy/shared'

/** Tvar odpovědi pluginu send-intent (SendIntent.checkSendIntentReceived). */
export interface SharedIntent {
  title?: string | null
  description?: string | null
  type?: string | null
  url?: string | null
}

/** Soubory a obsah z jiných aplikací (file://, content://) nejsou text; web odkaz ano. */
function isFileUri(value: string): boolean {
  return /^(file|content):/i.test(value)
}

/**
 * Text ke sdílení z intentu: předmět (`title`), popis (`description`) a odkaz nebo text (`url`;
 * u text/plain plugin vkládá do `url` celý sdílený text). Duplicity se sloučí, soubory se ignorují.
 * Vrací null, když v intentu žádný text není (obrázek, soubor, prázdné sdílení).
 */
export function sharedTextFromIntent(intent: SharedIntent | null | undefined): string | null {
  if (!intent) return null
  const type = (intent.type ?? '').toLowerCase()
  // Sdílený obrázek, video nebo dokument zatím neumíme; text/* a neznámý typ bereme.
  if (type && !type.startsWith('text/')) return null

  const parts = [intent.title, intent.description, intent.url]
    .map((p) => (typeof p === 'string' ? p.trim() : ''))
    .filter((p) => p !== '' && !isFileUri(p))
  // Předmět bývá obsažený v textu (prohlížeč sdílí titulek i s odkazem): neopakovat.
  const unique: string[] = []
  for (const part of parts) {
    if (unique.some((u) => u.includes(part))) continue
    for (let i = unique.length - 1; i >= 0; i--) {
      if (part.includes(unique[i]!)) unique.splice(i, 1)
    }
    unique.push(part)
  }
  const text = unique.join('\n').trim()
  if (!text) return null
  return text.length > AI_NOTE_MAX_LENGTH ? text.slice(0, AI_NOTE_MAX_LENGTH) : text
}

/** Cesta do chatu s předvyplněným textem. */
export function buddyShareLocation(text: string): { path: string; query: { text: string } } {
  return { path: '/buddy', query: { text } }
}
